// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jzmgcrxhpzztzljikyoa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp6bWdjcnhocHp6dHpsamlreW9hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY3ODkzNTMsImV4cCI6MjA1MjM2NTM1M30.keFFeY-BZ_B2MIdWtWL5isfO8hKIRHEfJ6NkRsDc3fY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);